import { Component, DestroyRef, inject, Input, OnInit, ViewChild } from '@angular/core';
import { FlashPoolsAdminComponent } from 'src/app/admin/parcs/flash/flash-pools-admin/flash-pools-admin.component';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import { AppGeneralStateService } from 'src/app/app-general-state.service';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { ProcessingBannerComponent } from 'src/app/shared/ui/processing-banner/processing-banner.component';
import { ParcsDataService } from 'src/app/core/services/data/parcs-data.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MessageDialogService } from 'src/app/core/services/helper/message-dialog.service';
import { IFlashValidateCredentialRequest } from 'src/app/shared/code/interfaces/parcs-interfaces';
import { MatTabsModule } from '@angular/material/tabs';

@Component({
  selector: 'app-flash-setup-home',
  standalone: true,
  imports: [
    MatCardModule,
    FormsModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatInputModule,
    MatOptionModule,
    ReactiveFormsModule,
    MatStepperModule,
    MatButtonModule,
    MatSelectModule,
    MatButtonToggleModule,
    ProcessingBannerComponent,
    MatTabsModule,
    
  ],
  templateUrl: './flash-setup-home.component.html',
  styleUrl: './flash-setup-home.component.scss'
})
export class FlashSetupHomeComponent implements OnInit {
  @ViewChild('stepper') private parcsStepper: MatStepper;

  selectedPARCS: string = '';
  isActivationInProgress: boolean = true;
  _selectedParcsId: string = '';
  _selectedParcsName: string = '';
  locationIdError: boolean = false;
  isProcessing: boolean = false;
  isCredentialValid: boolean | undefined = undefined;
  processingMessage: string = '';
  

  @Input()
  set parcsId(value: string) {
    if (value && value.length > 0) {
      this._selectedParcsId = value;
    }
  }

  @Input()
  set parcsName(value: string) {
    if (value && value.length > 0) {
      this._selectedParcsName = value;
    }
  }

  //Services
  _appGeneralState = inject(AppGeneralStateService);
  private readonly _formBuilder = inject(FormBuilder);
  private readonly _parcsDataService = inject(ParcsDataService);
  private readonly _messageDialogService = inject(MessageDialogService);
  _destroyRefService = inject(DestroyRef);

  readonly parcsLocationForm = this._formBuilder.group({
    locationId: '',
  });

  readonly parcsTokenForm = this._formBuilder.group({
    securityToken: '',
  });

  parcsReviewForm = this._formBuilder.group({
    locationId: ['', Validators.required],
    facilityName: ['', Validators.required],
  });

  ngOnInit(): void {}

  onParcsStepOne(): void {
    this.parcsStepper.next();
  }

  onParcsStepTwo(): void {
    this.parcsStepper.next();
  }

  onParcsSuccessfullyValidated(): void {}

  onSubmitFlashFacility(): void {
    this.isProcessing = true;
    this.processingMessage = 'Validating Flash credentials...';
    const activationData: IFlashValidateCredentialRequest = {} as IFlashValidateCredentialRequest;

    activationData.lotNumber = this._appGeneralState.currentLotNumber;
    activationData.locationId = this.parcsLocationForm.get('locationId')?.value?.trim() || '';
    activationData.securityToken = this.parcsTokenForm.get('securityToken')?.value?.trim() || '';

    this._parcsDataService
      .flash_ValidateCredentials(
        activationData
      )
      .pipe(takeUntilDestroyed(this._destroyRefService))
      .subscribe({
        next: (res) => {
          this.isCredentialValid = res.isValid;
        },
        error: (err: any) => {
          this.isProcessing = false;
          this.isCredentialValid = false;
          this._messageDialogService.snackBarTopCenterTimed('An error occurred while validating the Flash credentials.', 3000);
        },
        complete: () => {
          this.isProcessing = false;
          console.log('Credential validation complete. isCredentialValid:', this.isCredentialValid);
          if (this.isCredentialValid) {
            this.parcsStepper.next();
          }
          else
          {
            this._messageDialogService.snackBarTopCenterTimed('The security token is invalid for this location id.', 3000);
          }
        },
      });
  }

  onSetParcsConfiguredToFinished(): void {}

  validateParcsFacilityExists(facilityId: string): void {}
}
